module.exports = __webpack_public_path__ + "static/invoker-a80e44a4a378f3a49d682b7a14d06fcc.pdf";